import styled from 'styled-components';
import { hex2rgb } from '~/src/helpers/color';
import phoneDecorator from '@ertelecom/ui-react/components/inputSimple/decorators/phoneDecorator';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import InputInstance from '@ertelecom/ui-react/components/input';
import InputSimple from '@ertelecom/ui-react/components/inputSimple';
import { MEDIA, COLORS } from '~/src/components/TariffDetail/styled';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';

const inputPhone = phoneDecorator(InputSimple);

export const Wrapper = styled.div`
    display: block;
    padding: 30px 0;
`;

export const Message = styled.div`
    background: ${({ status }) => `rgba(${hex2rgb(!status ? COLORS.lightRed : COLORS.lightGreen)},0.2)`};
    margin-bottom: 20px;
    border-radius: 4px;
    padding: 20px;
    max-width: 100%;
`;

export const Note = styled.div`
    display: block;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.darkGrey};
    width: ${({ isSideBar }) => isSideBar ? 'auto' : '100%'};
    padding: ${({ isSideBar }) => isSideBar ? '15px 0 5px' : '0'};
    @media(${MEDIA.tablet}) {
        width: ${({ isSideBar }) => isSideBar ? 'auto' : '50%'};
    }
    @media(${MEDIA.mobile}) {
        width: auto;
        padding: 0 0 15px;
    }

    & a {
        color: inherit;
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
`;

export const Submit = styled(StyledButton)`
    font-weight: 400;
    width: ${({ isSideBar }) => isSideBar ? '100%' : '50%'};
    margin: 0 0 16px;
    @media(${MEDIA.mobile}) {
        margin-bottom: 12px;
        width: 100%;
    }
`;

export const Input = styled(InputInstance)`
    margin-bottom: 20px;
    span {
      overflow: visible;
      z-index: 3;
    }
`;

export const InputPhone = styled(inputPhone)`
    margin-bottom: 20px;
    span {
      overflow: visible;
      z-index: 3;
    }
`;

export const Row = styled.div`
    margin-bottom: ${({ isSideBar }) => isSideBar ? '10px' : '0'};
    width: 100%;
    flex-wrap: nowrap;
    flex-direction: ${({ isSideBar }) => isSideBar ? 'column' : 'row'};
        & > *:first-child {
            margin-right: ${({ isSideBar }) => isSideBar ? '0' : '20px'};
        }
        ${({ isSideBar }) => isSideBar ? '&:last-child {margin-bottom: 0;}' : null}    
        
    @media(${MEDIA.mobile}) {
        margin-bottom: 10px;
        flex-direction: column;
        &:last-child {
            margin-bottom: 0;
        }
        & > *:first-child {
            margin-right: 0;
        }
    }
`;

export const Info = styled.div`
    display: block;
    width: 100%;
    font-size: 16px;
    font-family: ${FONTS.light};
`;
